import * as React from "react"

import Layout from "../components/layout"
import Seo from "../components/seo"

class Store extends React.Component {
  constructor(props) {
    super(props)

    this.state = {}
  }

  render() {
    return (
      <Layout countryCode={this.props.pageContext.countryCode || "JM"}>
        <Seo
          title="Store"
          countryCode={this.props.pageContext.countryCode || "JM"}
        />
        <iframe
          src="https://csglearn.fygaroshops.com"
          style={{ height: "900px" }}
        />
      </Layout>
    )
  }
}

export default Store
